import request from "@/utils/request";

export default function getMerchantByWeChatMPId(wechatMPId) {
    return request({
        url: `/merchant/agency/get/${wechatMPId}`,
        method: 'get',
    })
}
